"use client";

import { useEffect, useState } from "react";
import Link from "next/link";
import { Button } from "@/components/ui/button";

export function AuthButtons() {
  const [state, setState] = useState<"loading" | "guest" | "user">("loading");

  useEffect(() => {
    // Gate on `isRegistered`, not `authenticated`. /auth/me returns
    // `authenticated: true` for anonymous guest sessions too (the
    // sessionToken cookie used to track anon trades), so checking
    // `authenticated` would render the logged-in CTAs to guests.
    fetch("/api/v1/auth/me")
      .then((r) => r.json())
      .then((d) => setState(d.isRegistered ? "user" : "guest"))
      .catch(() => setState("guest"));
  }, []);

  if (state === "loading") {
    return <div className="h-11 w-64 rounded-lg bg-muted animate-pulse" />;
  }

  if (state === "user") {
    return (
      <div className="flex flex-wrap justify-center gap-3">
        <Link href="/sell">
          <Button size="lg" className="min-w-36">Start Selling</Button>
        </Link>
        <Link href="/dashboard">
          <Button variant="outline" size="lg">My Dashboard</Button>
        </Link>
      </div>
    );
  }

  return (
    <div className="flex flex-wrap justify-center gap-3">
      <Link href="/sell">
        <Button size="lg" className="min-w-36">Start Selling</Button>
      </Link>
      <Link href="/auth/register">
        <Button variant="outline" size="lg">Create Account</Button>
      </Link>
    </div>
  );
}
